// Resolves a media item's URL at the given size, falling back to the original
// for photo objects and returning legacy string URLs unchanged.
export const photoSrc = (media, usage) => {
  if (media == null) return null;

  if ('object' === typeof media) {
    return media[usage] || media.url || null;
  }

  return media;
};

export const isVideo = media =>
  !!media && 'object' === typeof media && ['youtube'].includes(media.type);
